import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { useIvaStore } from '@/store/erp/shared/iva.store';
import { usePlanStore } from '@/store/erp/system-settings/plan.store';

export type ClientesModuleProps = {};

const ClientesModule: React.FC<ClientesModuleProps> = () => {
  const getIva = useIvaStore(s => s.getIva);
  const getPlans = usePlanStore(s => s.getPlans);


  useEffect(() => {
    (async () => {
      const results = await Promise.allSettled([
        getIva(),
        getPlans({
          page_size: 100,
          estado: true
        })
      ]);
      results.forEach((result, index) => {
        if (result.status === 'rejected') {
          console.error(`Data load failed at position ${index}:`, result.reason);
        }
      });
    })();
  }, []);

  return (
    <>
      <Outlet />
    </>
  );
};

export default ClientesModule;
